export default __webpack_public_path__ + "static/media/15-An-Apple-A-Day.1a3d6ca0.jpg";